import { useEffect, useState } from "react";
import { EffectivePlanView } from "@/components/effective-plan/EffectivePlanView";
import type { WeekKey } from "@/components/effective-plan/planFormat";
import { TeacherPrintBar } from "@/components/timetable-export/TeacherPrintBar";
import {
  timetableExportApi,
  type ExportOptions,
} from "@/services/api/timetableExport";

export function EffectiveStundenplanPage() {
  const [teacherId, setTeacherId] = useState<string | null>(null);
  const [week, setWeek] = useState<WeekKey | null>(null);
  const [printOpen, setPrintOpen] = useState(false);
  const [options, setOptions] = useState<ExportOptions | null>(null);

  useEffect(() => {
    timetableExportApi
      .options()
      .then(setOptions)
      .catch(() => setOptions(null));
  }, []);

  return (
    <div className="flex h-[calc(100vh-3.5rem)] flex-col p-3">
      <EffectivePlanView
        teacherId={teacherId}
        directory="plan-teachers"
        live
        onTeacherId={setTeacherId}
        onWeek={setWeek}
        toolbarExtra={
          options?.can_export ? (
            <button
              type="button"
              disabled={!teacherId}
              title={teacherId ? undefined : "Zuerst eine Person wählen"}
              className={`rounded border px-2 py-1 text-xs disabled:cursor-not-allowed disabled:opacity-40 ${printOpen ? "border-blue-600 bg-blue-50 font-medium text-blue-700" : "border-gray-300 bg-white text-gray-700"}`}
              onClick={() => {
                if (teacherId) setPrintOpen((open) => !open);
              }}
            >
              Drucken
            </button>
          ) : null
        }
        overlay={
          printOpen && options?.can_export && teacherId ? (
            <TeacherPrintBar
              options={options}
              week={week}
              subjectTeacherId={teacherId}
              note="Die gewählte Person. Meier bleibt Lehrer."
              onClose={() => setPrintOpen(false)}
            />
          ) : null
        }
      />
    </div>
  );
}
